module.exports = __webpack_public_path__ + "static/media/icon_add.a56eacd6.svg";